<script>
import { getRelationshipTypesApi } from '@modules/asset-management/api/asset-relationship-type-api'

export default {
  name: 'RelationshipProvider',
  provide() {
    const AssetRelationshipContext = {}
    Object.defineProperty(AssetRelationshipContext, 'relationshipTypes', {
      enumerable: true,
      get: () => this.relationshipTypes,
    })
    return { AssetRelationshipContext }
  },
  data() {
    return {
      relationshipTypes: [],
    }
  },
  created() {
    this.getAssetRelationshipTypes()
  },
  methods: {
    getAssetRelationshipTypes() {
      getRelationshipTypesApi().then(({ items }) => {
        this.relationshipTypes = items.map((d) => ({
          id: d.id,
          directName: d.directName,
          inverseName: d.inverseName,
        }))
      })
    },
  },
  render() {
    return this.$scopedSlots.default({})
  },
}
</script>
